import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LoginRequest } from '../models/requests/login-request';
import { LoginResponseData } from '../models/responses/login-response-data';
import { ApiResponseObject } from '../models/responses/api-response-object';
import { Profile } from '../models/profile';
import { userVM } from '../models/requests/userVm';
import { ChangePasswordVm } from '../models/requests/ChangePasswordVm';
import { UserInSystem } from '../models/usersInSystem';

@Injectable({
  providedIn: 'root'
})
export class UserService {

 
  constructor(private httpClient: HttpClient) { }

  requestLoginCode(userEmail: string): Observable<ApiResponseObject<Boolean>> {
    
    return this.httpClient.get<ApiResponseObject<Boolean>>(`${environment.apiUrl}/Accounts/GetLoginCode/${userEmail}`);
  }

  validateLoginCode(token: string): Observable<ApiResponseObject<LoginResponseData>> {
    return this.httpClient.post<ApiResponseObject<LoginResponseData>>(`${environment.apiUrl}/Accounts/ValidateLoginCode/${token}`, token );
  }
  
  login(loginRequest: LoginRequest): Observable<ApiResponseObject<LoginResponseData>> {
   
    return this.httpClient.post<ApiResponseObject<LoginResponseData>>(`${environment.apiUrl}/Accounts`, loginRequest);
  }
  loginAs(em: string): Observable<ApiResponseObject<any>> {
    
    return this.httpClient.post<ApiResponseObject<any>>(`${environment.apiUrl}/Accounts/LoginAs/${em}`, em,);
  }

  passwordReset(loginRequest: LoginRequest): Observable<ApiResponseObject<LoginResponseData>> {
   
    return this.httpClient.post<ApiResponseObject<LoginResponseData>>(`${environment.apiUrl}/Accounts/ForgotPassword`, loginRequest);
  }

  getUsers(): Observable<ApiResponseObject<Profile[]>> {
    return this.httpClient.get<ApiResponseObject<Profile[]>>(`${environment.apiUrl}/User/getAllUsers`);
  }

  createUser(userrequest: userVM): Observable<ApiResponseObject<Profile>> {
   
    return this.httpClient.post<ApiResponseObject<Profile>>(`${environment.apiUrl}/User`, userrequest);
  }

  chanegPassword(changePasswordvm: ChangePasswordVm): Observable<ApiResponseObject<LoginResponseData>> {
   
    return this.httpClient.post<ApiResponseObject<LoginResponseData>>(`${environment.apiUrl}/Accounts/ChangePassword`, changePasswordvm);
  }
  getManagersUsers(): Observable<ApiResponseObject<Profile[]>> {
    return this.httpClient.get<ApiResponseObject<Profile[]>>(`${environment.apiUrl}/User/getManagers`);
  }
  assignRolesToUser(vm: any): Observable<ApiResponseObject<Profile>> {
   
    return this.httpClient.post<ApiResponseObject<Profile>>(`${environment.apiUrl}/User/assignRolesToUser`, vm);
  }
  removeRoleToUser(vm: any): Observable<ApiResponseObject<Profile>> {
   
    return this.httpClient.post<ApiResponseObject<Profile>>(`${environment.apiUrl}/User/removeRoleToUser`, vm);
  }

  AssignDOA(obj: any): Observable<ApiResponseObject<Profile>> {
   ;
    return this.httpClient.post<ApiResponseObject<Profile>>(`${environment.apiUrl}/User/AssignDOA`, obj);
  }

  getHRBPS(): Observable<ApiResponseObject<Profile[]>> {
    
    return this.httpClient.get<ApiResponseObject<Profile[]>>(`${environment.apiUrl}/User/getHRBPS`);
  }

  getProcurementDirector(): Observable<ApiResponseObject<Profile[]>> {
    
    return this.httpClient.get<ApiResponseObject<Profile[]>>(`${environment.apiUrl}/User/getProcurementDirector`);
  }

  getOHRDirector(): Observable<ApiResponseObject<Profile[]>> {
    return this.httpClient.get<ApiResponseObject<Profile[]>>(`${environment.apiUrl}/User/getOHRDirector`);
  }
  
  getCEO(): Observable<ApiResponseObject<Profile[]>> {
    return this.httpClient.get<ApiResponseObject<Profile[]>>(`${environment.apiUrl}/User/getCEO`);
  }

  getHRSharedServices(): Observable<ApiResponseObject<Profile[]>> {
    return this.httpClient.get<ApiResponseObject<Profile[]>>(`${environment.apiUrl}/User/getSharedServices`);
  }

  getFunctionalDirectors(): Observable<ApiResponseObject<Profile[]>> {
    return this.httpClient.get<ApiResponseObject<Profile[]>>(`${environment.apiUrl}/User/getFunctionalDirectors`);
  }

  getUsersInSystem(): Observable<ApiResponseObject<UserInSystem[]>> {
    return this.httpClient.get<ApiResponseObject<UserInSystem[]>>(`${environment.apiUrl}/User/getAllUsersInsystem`);
  }

  passwordlessSignIn(objec: any): Observable<ApiResponseObject<LoginResponseData>> {
   
    return this.httpClient.post<ApiResponseObject<LoginResponseData>>(`${environment.apiUrl}/Accounts/PasswordlessSignIn`, objec);
  }
  loginWithToken(request: {token: string}): Observable<ApiResponseObject<any>> {
    return this.httpClient.post<ApiResponseObject<any>>(`${environment.apiUrl}/Accounts/TokenLogin`, request);
  }
}
